import React from 'react';
import { ArrowRight, Award, CheckCircle, TrendingUp, Users, Zap } from 'lucide-react';
export const Hero = () => {
  return <section id="home" className="relative bg-gradient-to-br from-primary-50 via-white to-primary-50/30 py-12 sm:py-16 md:py-20 lg:py-32 overflow-hidden" data-id="element-877">
      {/* Decorative background elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true" data-id="element-878">
        <div className="absolute top-20 right-10 w-64 sm:w-96 h-64 sm:h-96 bg-primary-100 rounded-full mix-blend-multiply filter blur-3xl opacity-40 animate-blob" data-id="element-879"></div>
        <div className="absolute bottom-20 left-10 w-64 sm:w-96 h-64 sm:h-96 bg-accent-100 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob animation-delay-2000" data-id="element-880"></div>
        <div className="absolute top-1/2 left-1/2 w-64 sm:w-96 h-64 sm:h-96 bg-primary-200 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-4000" data-id="element-881"></div>
      </div>

      <div className="container relative z-10" data-id="element-882">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16" data-id="element-883">
          <div className="w-full lg:w-1/2 space-y-6 sm:space-y-8 animate-slideUp text-center lg:text-left" data-id="element-884">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight" data-id="element-885">
              Empowering Kenyan{' '}
              <span className="text-primary-600 relative inline-block" data-id="element-886">
                Businesses
                <svg className="absolute -bottom-1 sm:-bottom-2 left-0 w-full" height="12" viewBox="0 0 200 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-887">
                  <path d="M2 8C60 3 140 3 198 8" stroke="#3d8b68" strokeWidth="4" strokeLinecap="round" data-id="element-888" />
                </svg>
              </span>{' '}
              to Thrive
            </h1>

            <p className="text-lg sm:text-xl md:text-2xl font-semibold text-primary-600 italic" data-id="element-889">
              "The Business Partner taking you to the next Level."
            </p>

            <p className="text-base sm:text-lg md:text-xl text-gray-600 leading-relaxed max-w-2xl mx-auto lg:mx-0" data-id="element-890">
              Access flexible business financing with competitive rates, quick
              approval, and personalized support. Join 5,000+ successful Kenyan
              entrepreneurs who trust Geldhaus.
            </p>

            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 pt-4 justify-center lg:justify-start" data-id="element-891">
              <a href="/apply" className="btn-primary flex items-center justify-center group text-base sm:text-lg px-6 sm:px-8 py-3 sm:py-4" data-id="element-892">
                Get Started
                <ArrowRight size={20} className="ml-2 group-hover:translate-x-1 transition-transform duration-200" aria-hidden="true" data-id="element-893" />
              </a>
              <a href="#ai-agent" className="btn-secondary flex items-center justify-center text-base sm:text-lg px-6 sm:px-8 py-3 sm:py-4" data-id="element-894">
                Talk to AI Assistant
              </a>
            </div>

            {/* Trust Indicators */}
            <div className="grid grid-cols-3 gap-4 sm:gap-6 pt-6 sm:pt-8 border-t border-gray-200" data-id="element-895">
              <div className="text-center lg:text-left" data-id="element-896">
                <div className="flex items-center gap-2 mb-1 justify-center lg:justify-start" data-id="element-897">
                  <Award size={18} className="text-primary-600 flex-shrink-0" aria-hidden="true" data-id="element-898" />
                  <p className="text-xl sm:text-2xl font-bold text-gray-900" data-id="element-899">
                    90%
                  </p>
                </div>
                <p className="text-xs sm:text-sm text-gray-600" data-id="element-900">
                  Approval Rate
                </p>
              </div>
              <div className="text-center lg:text-left" data-id="element-901">
                <div className="flex items-center gap-2 mb-1 justify-center lg:justify-start" data-id="element-902">
                  <CheckCircle size={18} className="text-primary-600 flex-shrink-0" aria-hidden="true" data-id="element-903" />
                  <p className="text-xl sm:text-2xl font-bold text-gray-900" data-id="element-904">
                    5,000+
                  </p>
                </div>
                <p className="text-xs sm:text-sm text-gray-600" data-id="element-905">
                  Businesses Supported
                </p>
              </div>
              <div className="text-center lg:text-left" data-id="element-906">
                <div className="flex items-center gap-2 mb-1 justify-center lg:justify-start" data-id="element-907">
                  <Zap size={18} className="text-primary-600 flex-shrink-0" aria-hidden="true" data-id="element-908" />
                  <p className="text-xl sm:text-2xl font-bold text-gray-900" data-id="element-909">
                    1-12 Hrs
                  </p>
                </div>
                <p className="text-xs sm:text-sm text-gray-600" data-id="element-910">
                  Fast Approval
                </p>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-1/2 animate-slideUp" data-id="element-911">
            {/* Illustration: Kenyan Business Growth */}
            <div className="relative max-w-lg mx-auto" data-id="element-912">
              <svg viewBox="0 0 500 500" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto" role="img" aria-label="Illustration of Kenyan business growth and success" data-id="element-913">
                <title data-id="element-914">Kenyan Business Growth</title>
                {/* Background circle */}
                <circle cx="250" cy="250" r="200" fill="#f0fdf4" opacity="0.5" data-id="element-915" />

                {/* Growth chart bars */}
                <rect x="80" y="320" width="40" height="80" rx="8" fill="#3d8b68" data-id="element-916" />
                <rect x="140" y="280" width="40" height="120" rx="8" fill="#3d8b68" data-id="element-917" />
                <rect x="200" y="240" width="40" height="160" rx="8" fill="#3d8b68" data-id="element-918" />
                <rect x="260" y="200" width="40" height="200" rx="8" fill="#2d6b4f" data-id="element-919" />
                <rect x="320" y="160" width="40" height="240" rx="8" fill="#2d6b4f" data-id="element-920" />
                <rect x="380" y="120" width="40" height="280" rx="8" fill="#2d6b4f" data-id="element-921" />

                {/* Upward trend line */}
                <path d="M 100 340 L 160 300 L 220 260 L 280 220 L 340 180 L 400 140" stroke="#f59e0b" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" fill="none" data-id="element-922" />

                {/* Arrow at end */}
                <path d="M 390 150 L 400 140 L 395 130" stroke="#f59e0b" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" fill="none" data-id="element-923" />

                {/* Business person silhouette */}
                <circle cx="100" cy="100" r="25" fill="#2d6b4f" data-id="element-924" />
                <path d="M 75 130 Q 100 125 125 130 L 125 180 Q 100 185 75 180 Z" fill="#3d8b68" data-id="element-925" />

                {/* Money/coin symbols */}
                <circle cx="420" cy="80" r="20" fill="#fbbf24" opacity="0.8" data-id="element-926" />
                <text x="420" y="90" fontSize="24" fontWeight="bold" fill="#92400e" textAnchor="middle" data-id="element-927">
                  KSh
                </text>

                <circle cx="380" cy="50" r="15" fill="#fbbf24" opacity="0.6" data-id="element-928" />
                <text x="380" y="57" fontSize="18" fontWeight="bold" fill="#92400e" textAnchor="middle" data-id="element-929">
                  KSh
                </text>

                <circle cx="450" cy="60" r="12" fill="#fbbf24" opacity="0.6" data-id="element-930" />
                <text x="450" y="66" fontSize="14" fontWeight="bold" fill="#92400e" textAnchor="middle" data-id="element-931">
                  KSh
                </text>

                {/* Success indicators */}
                <circle cx="150" cy="80" r="8" fill="#10b981" data-id="element-932" />
                <circle cx="200" cy="90" r="8" fill="#10b981" data-id="element-933" />
                <circle cx="250" cy="70" r="8" fill="#10b981" data-id="element-934" />

                {/* Building/business icon */}
                <rect x="40" y="360" width="30" height="40" rx="4" fill="#3d8b68" data-id="element-935" />
                <rect x="45" y="365" width="5" height="5" fill="#fff" data-id="element-936" />
                <rect x="55" y="365" width="5" height="5" fill="#fff" data-id="element-937" />
                <rect x="45" y="375" width="5" height="5" fill="#fff" data-id="element-938" />
                <rect x="55" y="375" width="5" height="5" fill="#fff" data-id="element-939" />
                <rect x="45" y="385" width="5" height="5" fill="#fff" data-id="element-940" />
                <rect x="55" y="385" width="5" height="5" fill="#fff" data-id="element-941" />
              </svg>

              {/* Floating Stats Card */}
              <div className="absolute -bottom-4 sm:-bottom-8 -left-4 sm:-left-8 bg-white p-4 sm:p-6 rounded-2xl shadow-2xl max-w-xs border border-gray-100 hidden sm:block" data-id="element-942">
                <div className="flex items-center gap-3 sm:gap-4" data-id="element-943">
                  <div className="w-12 h-12 sm:w-14 sm:h-14 bg-primary-100 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-944">
                    <TrendingUp size={24} className="text-primary-600" aria-hidden="true" data-id="element-945" />
                  </div>
                  <div data-id="element-946">
                    <p className="text-xs sm:text-sm text-gray-600 font-medium" data-id="element-947">
                      Fast Approval
                    </p>
                    <p className="text-xl sm:text-2xl font-bold text-primary-600" data-id="element-948">
                      1-12 Hours
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};